import i18next from "@app/i18n";

const enResources = {
    page_title: "Questionnaires",
    search_bar_placeholder: "Search",
    page_subtitle: "Manage your company’s external questionnaires",
    table_header_name: "Questionnaire",
    table_header_company: "Requested by",
    table_header_status: "Status",
    table_header_progress: "Completion",
    table_header_created_by: "Created by",
    table_header_deadline: "Due date",
    table_header_assignees: "Assignees",
    table_header_last_modified: "Last modified",
    create_questionnaire_modal_title: "Create new questionnaire",
    create_questionnaire_modal_subtitle_templates: "Start from a template",
    create_questionnaire_modal_subtitle_from_scratch:
        "Build your own questionnaire",
    create_questionnaire_modal_trigger_label: "New questionnaire",
    create_questionnaire_from_template_modal_trigger_label: "Browse templates",
    create_questionnaire_modal_cancel_label: "Cancel",
    create_questionnaire_modal_confirm_label: "Create",
    create_questionnaire_modal_tooltip_no_name:
        "You must add a name, chose the available locales and the default one",
    create_questionnaire_modal_name_placeholder: "Name",
    create_questionnaire_modal_description_placeholder: "Description",
    create_questionnaire_modal_requester_email_placeholder:
        "Requester email (optional)",
    create_questionnaire_modal_company_name_placeholder:
        "Requesting company (optional)",
    create_questionnaire_modal_deadline_placeholder: "Due date",
    create_questionnaire_modal_locale_placeholder: "Language",
    upload_questions_modal_trigger: "Upload questionaire",
    create_questionnaire_modal_trigger: "Create questionnaire",
    delete_questionnaire_modal_title: "Delete questionnaire",
    delete_questionnaire_modal_description:
        "Are you sure you want to delete this questionnaire?",
    delete_questionnaire_modal_confirm: "Delete",
    cancel: "Cancel",
    set_a_deadline: "Set a deadline",
    select_template: "Select template",
    start: "Start",
    build_my_own: "Build my own",
    available_soon: "Available soon",
    empty_state_title: "No questionnaire found",
    empty_state_subtitle: "Create a new questionnaire to get started",
    requested_by: "Requested by",
    requested_by_description:
        "Provide information about who requested the questionnaire.",
    locale_description:
        "Once a language is set, it can not be changed for this questionnaire.",
    tooltip_status_validated: "Complete",
    tooltip_status_in_progress: "In progress",
    tooltip_status_not_started: "Not started",
} as const;

type ResourcesKeys = keyof typeof enResources;

const frResources: Record<ResourcesKeys, string> = {
    page_title: "Questionnaires externes",
    search_bar_placeholder: "Rechercher",
    page_subtitle: "Gérez les questionnaires externes de votre entreprise",
    table_header_name: "Questionnaire",
    table_header_company: "Demandé par",
    table_header_status: "Statut",
    table_header_progress: "Progression",
    table_header_created_by: "Créé par",
    table_header_deadline: "Date limite",
    table_header_assignees: "Assignés",
    table_header_last_modified: "Dernière modification",
    create_questionnaire_modal_title: "Créer un nouveau questionnaire",
    create_questionnaire_modal_subtitle_templates:
        "Commencer à partir d'un modèle",
    create_questionnaire_modal_subtitle_from_scratch:
        "Créer un questionnaire personnalisé",
    create_questionnaire_modal_trigger_label: "Nouveau questionnaire",
    create_questionnaire_modal_trigger: "Créer un questionnaire",
    create_questionnaire_from_template_modal_trigger_label:
        "Parcourir les modèles",
    upload_questions_modal_trigger: "Importer un questionnaire",
    create_questionnaire_modal_cancel_label: "Annuler",
    create_questionnaire_modal_confirm_label: "Créer",
    create_questionnaire_modal_tooltip_no_name:
        "Vous devez ajouter un nom, choisir les langues disponibles et la langue par défaut",
    create_questionnaire_modal_name_placeholder: "Nom",
    create_questionnaire_modal_description_placeholder: "Description",
    create_questionnaire_modal_requester_email_placeholder:
        "Email du demandeur (optionnel)",
    create_questionnaire_modal_company_name_placeholder:
        "Entreprise (optionnel)",
    create_questionnaire_modal_deadline_placeholder: "Date limite",
    create_questionnaire_modal_locale_placeholder: "Langue",
    delete_questionnaire_modal_title: "Supprimer le questionnaire",
    delete_questionnaire_modal_description:
        "Êtes-vous sûr de vouloir supprimer ce questionnaire ?",
    delete_questionnaire_modal_confirm: "Supprimer",
    cancel: "Annuler",
    set_a_deadline: "Définir une date limite",
    select_template: "Sélectionner un modèle",
    start: "Commencer",
    build_my_own: "Créer mon propre questionnaire",
    available_soon: "Bientôt disponible",
    empty_state_title: "Aucun questionnaire trouvé",
    empty_state_subtitle: "Créez un nouveau questionnaire pour commencer",
    requested_by: "Demandé par",
    requested_by_description:
        "Fournissez des informations sur la personne qui a demandé le questionnaire.",
    locale_description:
        "Une fois une langue est définie, elle ne peut pas être changée pour ce questionnaire.",
    tooltip_status_validated: "Terminé",
    tooltip_status_in_progress: "En cours",
    tooltip_status_not_started: "Non commencé",
} as const;

export const keys = Object.fromEntries(
    Object.keys(enResources).map((key) => [key, key]),
) as Record<ResourcesKeys, ResourcesKeys>;
export const RESOURCE_NAME = "ExternalQuestionnaires";

i18next.addResourceBundle("en", RESOURCE_NAME, enResources);
i18next.addResourceBundle("fr", RESOURCE_NAME, frResources);
